jQuery.feature_import("js-meal-economy",
    () => require("./meal-economy-app"),
    mod => mod.feature_js_meal_economy
); 